/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Csv_To_Json_Deep_TitleInputs */

const en_csv_to_json_deep_title = /** @type {(inputs: Csv_To_Json_Deep_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Every value is a string, and that is the safe choice`)
};

const ko_csv_to_json_deep_title = /** @type {(inputs: Csv_To_Json_Deep_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`모든 값은 문자열이며, 그것이 안전한 선택입니다`)
};

const ja_csv_to_json_deep_title = /** @type {(inputs: Csv_To_Json_Deep_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`すべての値は文字列で、それが安全な選択です`)
};

/**
* | output |
* | --- |
* | "Every value is a string, and that is the safe choice" |
*
* @param {Csv_To_Json_Deep_TitleInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const csv_to_json_deep_title = /** @type {((inputs?: Csv_To_Json_Deep_TitleInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Csv_To_Json_Deep_TitleInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_csv_to_json_deep_title(inputs)
	if (locale === "ko") return ko_csv_to_json_deep_title(inputs)
	return ja_csv_to_json_deep_title(inputs)
});